/**
 * GET verifica la versión actual de la aplicación contra la API.
 */
import axiosController from "helpers/axiosController";

export const GETCheckVersion = async (loggedUser, feVersion) => {
  try {
    const token = loggedUser?.token;

    const response = await axiosController.get(
      `${process.env.REACT_APP_API_URL}/version-check?feVersion=${feVersion}`,
      {
        headers: {
          Accept: "text/plain",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    return response;
  } catch (error) {
    return (
      error?.response || {
        status: 500,
        data: { message: "Error al verificar versión" },
      }
    );
  }
};
